<template >
  <li :class="[
    { 'cursor-not-allowed': link.disabled },
    { 'cursor-wait-ov' : isGeneralLoading}
    ]" 
    v-if="!link.invisible">
    <router-link :to="{ name: link.path, params: link.params }" 
      v-if="!(role === 1 && link.path === 'configurations/users')"
      :class="[
        { 'router-link-disabled': (link.disabled || isGeneralLoading) },
      ]"
      href="#" 
      class="child flex items-center pl-18 pr-4 h-8 hover:bg-primary-100 dark:hover:bg-darkblue-600 active:bg-primary-200 group animate-hover">
      <span class="span-nav-link-container w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center cover-subnav"
        >
        <span class="link-name w-full truncate group-hover:text-primary dark:group-hover:text-primary dark:text-darkblue-200">
          <el-tooltip :open-delay="500" placement="right" :disabled="!link.info">
            <div slot="content">                    
              <div class="max-w-sm max-h-500p overflow-auto">                  
                  <div>
                    {{ link.info }}
                  </div>                  
              </div>
            </div>
            <div class="flex items-center">
              <span class="truncate" :class="{ 'color-link-disabled': link.warning === 2 }">
                {{ link.name }} 
              </span>
              <span v-if="link.warning === 1" class="k-icon k-i-warning color-warning ml-1 pr-1"/>
            </div>
          </el-tooltip>                                                     
        </span>
        <span v-if="link.counter" class="h-6 font-medium shadow flex-shrink-0 px-2 bg-white text-xs text-secondary flex items-center justify-center rounded-full"
          :class="{ 'color-link-disabled': link.warning === 2 }">
            {{ $n(link.counter, 'integer') }}
        </span>
      </span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'aside-nav-item-link',
  props: {
    link: {
      type: [Object],
      required: true
    },
    role: {
      type: String,
      default: null
    }

  },
  data: function () {
    return {
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-14;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
}

.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary dark:text-darkblue-200 font-medium;
  }
.color-link-disabled{
  @apply text-secondary-300;
}
.dark .color-link-disabled{
  @apply text-secondary-600;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .color-link-disabled{
    @apply text-secondary-800;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
    border-left-width: 4px!important;
  }
}
.dark .router-link-active .color-link-disabled {
  color: var(--darkblue-200);
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
